import 'dayjs/locale/en';
import 'dayjs/locale/fi';
import React from 'react';
import { useMessageGetter } from 'react-message-context';
import styled from 'styled-components/macro';
import { CalendarIcon, LocationIcon, UserFilledIcon } from '../../../assets';
import { useFormattedClockTime } from '../../../hooks';
import { formatDateTimeFromString } from '../../../utils';
import { Bold, H2, H3, H5, TextBlock } from '../Text';
import { PreviewContentBlock, Row } from '../layoutComponents';
import { MeetingMinutesFormState } from './schema';

const PreviewContent = styled(PreviewContentBlock)``;
const MeetingDetails = styled(PreviewContentBlock)`
  gap: 16px;
`;
const MeetingItems = styled(PreviewContentBlock)``;
const MeetingItem = styled(PreviewContentBlock)`
  gap: 20px;
`;
const Signatures = styled(PreviewContentBlock)``;
const Signee = styled(PreviewContentBlock)`
  font-size: 16px;
  gap: 8px;
`;

type Props = { formData: MeetingMinutesFormState };

export const MeetingMinutesPreview = ({ formData }: Props): React.ReactElement => {
  const t = useMessageGetter('forms.meetingMinutes');
  const { formatClockTime } = useFormattedClockTime();

  const formattedDate = formData.date ? formatDateTimeFromString(formData.date) : '';

  const formattedTime = formatClockTime(formData.time);

  return (
    <PreviewContent>
      <H2>{formData.name}</H2>
      <MeetingDetails>
        <Row>
          <CalendarIcon />
          <Bold>{`${formattedDate}${formattedDate && formattedTime && ', '}${formattedTime}`}</Bold>
        </Row>
        <Row>
          <LocationIcon />
          <Bold>{formData.location}</Bold>
        </Row>
        <Row>
          <UserFilledIcon />
          {formData.participants}
        </Row>
      </MeetingDetails>
      <MeetingItems>
        {formData.items.map((item) => (
          <MeetingItem id={item.title}>
            <H5>{item.title}</H5>
            <TextBlock>{item.text}</TextBlock>
          </MeetingItem>
        ))}
      </MeetingItems>
      <Signatures>
        <H3>{t('signatures.title')}</H3>
        <Signee>
          <span>{t('chairperson')}:</span>
          <span>{formData.chairperson}</span>
        </Signee>
        <Signee>
          <span>{t('secretary')}:</span>
          <span>{formData.secretary}</span>
        </Signee>
      </Signatures>
    </PreviewContent>
  );
};
